export default __webpack_public_path__ + "static/media/UI-logo.3d36ee3f.svg";